
const initialState = {
    list: [],
    count: 0,
    filters: {
        point: null,
        id: null,
        phone: null,
    },
    paging: {
        start: 0,
        limit: 10
    },
};

export default function blockedOrders(state = initialState, action) {
    switch(action.type) {
      case 'SET_BLOCKEDORDERS_LIST': {
        return {
            ...state,
            list: action.data
        }
      }
      case 'SET_BLOCKEDORDERS_COUNT': {
        return {
            ...state,
            count: action.data
        }
      }
      case 'SET_BLOCKEDORDERS_FILTERS': {
        return {
            ...state,
            filters: action.filters
        }
      }
      case 'SET_BLOCKEDORDERS_PAGING': {
        return {
            ...state,
            paging: action.paging
        };
      }
    default: return state;
    }
  }